import Vue from 'vue';

export default class ToastUtil {
  vm = null;

  constructor() {
    this.vm = new Vue();
  }
  errorToast(message) {
    this.vm.$bvToast.toast(message, {
      variant: 'danger',
      toaster: 'b-toaster-top-right',
      solid: true,
      autoHideDelay: 5000,
      appendToast: false,
    });
  }

  warningToast(message) {
    this.vm.$bvToast.toast(message, {
      variant: 'warning',
      toaster: 'b-toaster-top-right',
      solid: true,
      autoHideDelay: 5000,
      appendToast: false,
    });
  }

  successToast(message) {
    this.vm.$bvToast.toast(message, {
      variant: 'success',
      toaster: 'b-toaster-top-right',
      solid: true,
      autoHideDelay: 5000,
      appendToast: false,
    });
  }
}
